/* VOROG — LA ROULETTE, MOTEUR PARTAGE.
   Deux sections s en servent : les caracteristiques rash / short, et les
   avis clients. Il vivait dans une balise {% javascript %} de la premiere,
   ou Shopify l enveloppe d un garde « cette section est-elle sur la page ? ».
   Sur la page FAQ, qui n a que les avis, il ne s executait donc jamais.
   En fichier a part, chaque section qui en a besoin le demande, et le
   navigateur ne le prend qu une fois pour toute la visite.
   Il est idempotent : le drapeau `vfsInit` empeche une seconde passe sur une
   racine deja traitee, donc deux sections sur la meme page ne se genent pas. */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-vorog-fs]').forEach(function (root) {
      if (root.dataset.vfsInit) return;
      root.dataset.vfsInit = '1';
      var items = root.querySelectorAll('[data-vfs-item]');
      var anchors = root.querySelectorAll('[data-vfs-anchor]');
      var imgs = root.querySelectorAll('[data-vfs-img]');
      var sentinels = root.querySelectorAll('[data-vfs-step]');
      if (!items.length) return;

      // `data-vfs-ring` ferme la roulette en anneau. Sans lui, rien ne change :
      // les caractéristiques rash / short gardent leur pile en ligne droite.
      var anneau = root.hasAttribute('data-vfs-ring');
      var cran = 0;

      // La combustion est entièrement en CSS (voir vfs-burn / vfs-flip) :
      // elle se cale sur la phase ÉPINGLÉE elle-même, que les crans ne
      // recouvrent pas (mesuré : le cran 1 tombe avant l'épinglage, le 4
      // après).
      function activate(idx) {
        // les sentinelles livrent une chaîne, activate(0) un nombre : on tranche
        idx = parseInt(idx, 10) || 0;
        cran = idx;

        // « Tout afficher » change le nombre de cartes dépliées, donc la taille
        // de l'anneau. Toutes les lectures AVANT toutes les écritures : lire
        // une position après avoir posé un style refait la mise en page.
        var n = 0;
        if (anneau) items.forEach(function (el) { if (el.offsetParent) n++; });

        items.forEach(function (el) {
          var off = parseInt(el.dataset.vfsItem, 10) - idx;
          // Distance comptée SUR LE CERCLE : passé la moitié de l'anneau, la
          // carte revient par l'autre côté. En ligne droite, la première
          // finissait à huit crans — pivotée au-delà du quart de tour, donc
          // écrite à l'envers, et emportée hors de l'écran.
          if (anneau && n > 2) {
            if (off * 2 > n) off -= n;
            else if (off * 2 <= -n) off += n;
          }
          el.classList.toggle('is-active', off === 0);
          // la roulette : chaque carte connaît sa distance à l'active
          el.style.setProperty('--off', off);
          el.style.setProperty('--d', Math.abs(off));
        });
        anchors.forEach(function (el) { el.classList.toggle('is-active', parseInt(el.dataset.vfsAnchor, 10) === idx); });
        imgs.forEach(function (el) { el.classList.toggle('is-active', parseInt(el.dataset.vfsImg, 10) === idx); });
      }

      var stepObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          // Le cran s'entend AU passage, pas à l'arrivée : c'est le même
          // instant que le basculement des cartes. Le son se tait de lui-même
          // si l'interrupteur de l'en-tête est éteint.
          var suivant = parseInt(entry.target.dataset.vfsStep, 10) || 0;
          if (suivant !== cran && window.VorogSon) window.VorogSon.jouer('cran');
          activate(entry.target.dataset.vfsStep);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      sentinels.forEach(function (s) { stepObserver.observe(s); });

      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      items.forEach(function (el) { revealObserver.observe(el); });

      // Sans ce rappel, les cartes révélées resteraient empilées au centre
      // jusqu'au prochain cran de défilement.
      if (anneau && root.dataset.vfsRingBox) {
        var boite = document.getElementById(root.dataset.vfsRingBox);
        if (boite) boite.addEventListener('change', function () { activate(cran); });
      }

      activate(0);
      root.classList.add('vorog-fs--ready', 'vorog-fs--mready');
    });
  })();
